import React, { useState, useEffect } from 'react';
import * as node_helpers from '../../ruleEditor_elements/helpers/NodeHelpers';


import ico_dest_0 from '../../../../assets/ico/ico_dest_0.svg';
import ico_dest_1 from '../../../../assets/ico/ico_dest_1.svg';
import ico_dest_2 from '../../../../assets/ico/ico_dest_2.svg';


const RuleVariableDestinationRow = ({ ruleId, index, destinations_list, variable_data_list, updateItem }) => {

    // Item
    const updateElement = (type, value) => {
        updateItem(index, type, value);
    }

    // Statut
    const [destStatus, setDestStatus] = useState(variable_data_list[index][0]);
    const [isStatusModif, setIsStatusModif] = useState(false);
    const handleStatusChange = (new_status) => {
        if (new_status !== destStatus && ['0', '1', '2'].includes(new_status)) {
            setDestStatus(new_status);
            updateElement("status", new_status);
        }
        setIsStatusModif(false);
    }

    // Commentaire
    const [destComment, setDestComment] = useState(variable_data_list[index][1]);
    const handleCommentChange = (new_comment) => {
        var newValue_encoded = node_helpers.string_encoding(new_comment);
        if (newValue_encoded !== destComment) {
            setDestComment(newValue_encoded);
            updateElement("comment", newValue_encoded);
        }
    }
    const handleCommentModif = (new_comment) => {
        var newValue_encoded = node_helpers.string_encoding(new_comment);
        setNbRows(getRowNb(newValue_encoded));
    }
    const getRowNb = (value) => {
        var nb_rows = 1;
        if (value !== "") {
            var nb_lines = value.split("\n").length;
            nb_rows = Math.max(1, nb_lines);
        }
        return nb_rows.toString();
    }
    const [nbRows, setNbRows] = useState(getRowNb(variable_data_list[index][1]));
    useEffect(() => {
        // Set default value of textarea
        document.getElementById(ruleId + "_var_destinations_" + index + "_input_string_long").value = node_helpers.string_decoding(variable_data_list[index][1]);
    }, [])

    return (
        <div className="app__ruleset_rule_variable_destinations_item_row">
            <div className="app__ruleset_rule_variable_destinations_item_row_1">{destinations_list[index].subdest}</div>
            <div className="app__ruleset_rule_variable_destinations_item_row_2">
                {destStatus === '0' &&
                    <div className="app__ruleset_rule_variable_destinations_status_label app__ruleset_rule_variable_destinations_status_label_0" onClick={() => { setIsStatusModif(true) }}>
                        <img src={ico_dest_0} />
                        <span>interdite</span>
                    </div>
                }
                {destStatus === '1' &&
                    <div className="app__ruleset_rule_variable_destinations_status_label app__ruleset_rule_variable_destinations_status_label_1" onClick={() => { setIsStatusModif(true) }}>
                        <img src={ico_dest_1} />
                        <span>autorisée</span>
                    </div>
                }
                {destStatus === '2' &&
                    <div className="app__ruleset_rule_variable_destinations_status_label app__ruleset_rule_variable_destinations_status_label_2" onClick={() => { setIsStatusModif(true) }}>
                        <img src={ico_dest_2} />
                        <span>autorisée sous conditions</span>
                    </div>
                }
                {isStatusModif &&
                    <div className="app__ruleset_rule_variable_destinations_status_container scale-up-top" onMouseLeave={() => { setIsStatusModif(false) }}>
                        {/* <div className="app__ruleset_rule_variable_destinations_status_item">autorisée</div>
                        <div className="app__ruleset_rule_variable_destinations_status_item">autorisée sous conditions</div> */}
                        <div className="app__ruleset_rule_variable_destinations_status_label app__ruleset_rule_variable_destinations_status_label_white" onClick={() => { handleStatusChange('0') }}>
                            <img src={ico_dest_0} />
                            <span>interdite</span>
                        </div>
                        <div className="app__ruleset_rule_variable_destinations_status_label app__ruleset_rule_variable_destinations_status_label_white" onClick={() => { handleStatusChange('1') }}>
                            <img src={ico_dest_1} />
                            <span>autorisée</span>
                        </div>
                        <div className="app__ruleset_rule_variable_destinations_status_label app__ruleset_rule_variable_destinations_status_label_white" onClick={() => { handleStatusChange('2') }}>
                            <img src={ico_dest_2} />
                            <span>autorisée sous conditions</span>
                        </div>
                    </div>
                }
            </div>
            <div className="app__ruleset_rule_variable_destinations_item_row_3">
                {/* {destComment} */}
                <textarea id={`${ruleId}_var_destinations_${index}_input_string_long`} className={`app__ruleset_rule_variable_input_destinations_textarea`} rows={nbRows} onChange={(e) => { handleCommentModif(e.target.value) }} onBlur={(e) => { handleCommentChange(e.target.value) }}></textarea>
            </div>
        </div>
    );
};

export default RuleVariableDestinationRow;